// Redux Reducer for Product Purchase Order Component
import types from './productPurchaseOrder.types';

// Initial State
const initialState = {
  purchaseOrders: [],
  totalCount: 0,
  oldPurchaseOrders: [],
  totalOldCount: 0,
  poProductDetails: null,
  companyDetails: null,
  poTemplateDetails: null,
  filteredDevelopmentOrders: [],
  supplierFactories: [],
  createdPurchaseOrder: null,
  updatedPurchaseOrder: null,
  purchaseOrderDetails: null,
  purchaseOrderFiles: [],
  selectedFileDetails: null,
  lastPdfDownload: null,
  poLogsAndHistory: null,
  selectedPOLog: null,
};

// Reducer
const productPurchaseOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_PRODUCT_DETAILS:
      return {
        ...state,
        poProductDetails: action.payload,
      };
    case types.FETCH_COMPANY_DETAILS:
      return {
        ...state,
        companyDetails: action.payload,
      };
    case types.FETCH_PO_TEMPLATE_DETAILS:
      return {
        ...state,
        poTemplateDetails: action.payload,
      };
    case types.CLEAR_PO_TEMPLATE_DETAILS:
      return {
        ...state,
        poTemplateDetails: null,
      };
    case types.FETCH_FILTERED_DEVELOPMENT_ORDERS:
      return {
        ...state,
        filteredDevelopmentOrders: action.payload,
      };
    case types.CLEAR_FILTERED_DEVELOPMENT_ORDERS:
      return {
        ...state,
        filteredDevelopmentOrders: [],
      };
    case types.FETCH_SUPPLIER_FACTORIES:
      return {
        ...state,
        supplierFactories: action.payload?.doc || action.payload || [],
      };
    case types.CLEAR_SUPPLIER_FACTORIES:
      return {
        ...state,
        supplierFactories: [],
      };
    case types.CREATE_PURCHASE_ORDER_SUCCESS:
      return {
        ...state,
        createdPurchaseOrder: action.payload,
      };
    case types.UPDATE_PURCHASE_ORDER_SUCCESS:
      return {
        ...state,
        updatedPurchaseOrder: action.payload,
      };
    case types.FETCH_PURCHASE_ORDERS_LIST:
      return {
        ...state,
        purchaseOrders: action.payload?.data || [],
        totalCount: action.payload?.totalCount || 0,
      };
    case types.APPEND_PURCHASE_ORDERS:
      return {
        ...state,
        purchaseOrders: [...state.purchaseOrders, ...(action.payload?.data || [])],
      };
    case types.FETCH_PURCHASE_ORDER_DETAILS:
      return {
        ...state,
        purchaseOrderDetails: action.payload,
      };
    case types.DELETE_PURCHASE_ORDER_SUCCESS:
      return {
        ...state,
        purchaseOrders: state.purchaseOrders.filter((order) => order._id !== action.payload),
      };
    case types.BULK_DELETE_PURCHASE_ORDERS_SUCCESS:
      return {
        ...state,
        purchaseOrders: state.purchaseOrders.filter((order) => !action.payload.includes(order._id)),
      };
    case types.FETCH_PO_FILES_LIST:
      return {
        ...state,
        purchaseOrderFiles: action.payload?.data || [],
      };

    case types.FETCH_PO_FILE_DETAILS:
      return {
        ...state,
        selectedFileDetails: action.payload || null,
      };

    case 'CLEAR_SELECTED_FILE_DETAILS':
      return {
        ...state,
        selectedFileDetails: null,
      };

    case types.UPDATE_PO_FILE_SUCCESS:
      return {
        ...state,
        selectedFileDetails: action.payload || null,
        // Update the file in the list if it exists
        purchaseOrderFiles: state.purchaseOrderFiles.map((file) => (file._id === action.payload?._id ? { ...file, ...action.payload } : file)),
      };

    case types.DELETE_PO_FILE_SUCCESS:
      return {
        ...state,
        purchaseOrderFiles: state.purchaseOrderFiles.filter((file) => file._id !== action.payload),
        selectedFileDetails: state.selectedFileDetails?._id === action.payload ? null : state.selectedFileDetails,
      };

    case types.BULK_DELETE_PO_FILES_SUCCESS:
      return {
        ...state,
        purchaseOrderFiles: state.purchaseOrderFiles.filter((file) => !action.payload.includes(file._id)),
        selectedFileDetails: action.payload.includes(state.selectedFileDetails?._id) ? null : state.selectedFileDetails,
      };
    case types.FETCH_OLD_PURCHASE_ORDERS:
      return {
        ...state,
        oldPurchaseOrders: action.payload?.pos || action.payload?.data || [],
        totalOldCount: action.payload?.totalCount || 0,
      };
    case types.APPEND_OLD_PURCHASE_ORDERS:
      return {
        ...state,
        oldPurchaseOrders: [...state.oldPurchaseOrders, ...(action.payload?.pos || action.payload?.data || [])],
      };
    case types.DELETE_OLD_PURCHASE_ORDER_SUCCESS:
      return {
        ...state,
        oldPurchaseOrders: state.oldPurchaseOrders.filter((order) => order._id !== action.payload),
      };
    case types.BULK_DELETE_OLD_PURCHASE_ORDERS_SUCCESS:
      return {
        ...state,
        oldPurchaseOrders: state.oldPurchaseOrders.filter((order) => !action.payload.includes(order._id)),
      };
    case types.DOWNLOAD_PO_PDF:
      // Optional: Track PDF download activity in state
      return {
        ...state,
        lastPdfDownload: action.payload,
      };
    case types.UPDATE_PO_STATUS_SUCCESS:
      // Update the status of the specific PO in both arrays
      return {
        ...state,
        purchaseOrders: state.purchaseOrders.map((order) =>
          order._id === action.payload.orderId
            ? {
                ...order,
                status: action.payload.data?.status,
                actionDate: action.payload.data?.actionDate,
                actionBy: action.payload.data?.actionBy,
                statusComment: action.payload.data?.statusComment,
                deliveryDate: action.payload.data?.deliveryDate,
              }
            : order,
        ),
      };
    case types.FETCH_PO_LOGS_AND_HISTORY:
      return {
        ...state,
        poLogsAndHistory: action.payload,
      };
    case types.FETCH_PO_LOG_BY_ID:
      return {
        ...state,
        selectedPOLog: action.payload,
      };
    case types.FETCH_PO_LOG_DETAILS_BY_ID:
      return {
        ...state,
        selectedPOLog: action.payload,
      };
    case types.CLEAR_ALL_PO_DATA:
      // Reset all state to initial values when leaving CreateEditPO page
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default productPurchaseOrderReducer;
